(() => {
  const onReady = (cb) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  };

  function initConfetti() {
    const canvas = document.getElementById('bf-confetti-canvas');
    if (!canvas) return;

    const hero = document.getElementById('bf-hero') || canvas.parentElement;
    const ctx = canvas.getContext('2d');
    const density = Math.max(5, parseInt(canvas.dataset_density || canvas.getAttribute('data-density') || '50', 10));
    const parallaxPct = Math.max(0, Math.min(1, (parseInt(canvas.dataset_parallax || canvas.getAttribute('data-parallax') || '25', 10) / 100)));
    const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let particles = [];
    let width = 0, height = 0;
    let rafId = null;
    let scrollY = window.scrollY || window.pageYOffset || 0;

    const colors = ['#FFD166', '#EF476F', '#06D6A0', '#118AB2', '#8338EC', '#FB5607'];

    function resize() {
      const rect = hero.getBoundingClientRect();
      // Ensure the canvas matches the hero's size on screen
      width = hero.clientWidth;
      height = hero.clientHeight;
      canvas.width = width;
      canvas.height = height;
      // Recreate particles relative to current size
      createParticles();
    }

    function createParticles() {
      const count = isReducedMotion ? Math.floor(density * 0.4) : density;
      particles = new Array(count).fill(0).map(() => {
        const size = Math.random() * 6 + 3;
        return {
          x: Math.random() * width,
          y: Math.random() * height,
          r: size / 2,
          w: size,
          h: size * (0.4 + Math.random() * 0.6),
          color: colors[(Math.random() * colors.length) | 0],
          speedY: 0.15 + Math.random() * 0.6,
          speedX: (Math.random() - 0.5) * 0.3,
          rot: Math.random() * Math.PI,
          rotSpeed: (Math.random() - 0.5) * 0.03
        };
      });
    }

    function onScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);

      // Simple parallax: translate confetti slightly based on scroll progress over hero
      const heroTop = hero.getBoundingClientRect().top + (window.scrollY || 0);
      const progress = ((scrollY - heroTop) / (height || 1));
      const parallaxOffset = progress * parallaxPct * 60; // 60px max by default

      ctx.save();
      ctx.translate(0, parallaxOffset);

      particles.forEach(p => {
        // Update
        p.y += p.speedY;
        p.x += p.speedX;
        p.rot += p.rotSpeed;

        if (p.y - p.h > height) {
          p.y = -p.h;
          p.x = Math.random() * width;
        }
        if (p.x < -10) p.x = width + 10;
        if (p.x > width + 10) p.x = -10;

        // Draw rectangle confetti
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      ctx.restore();
      rafId = requestAnimationFrame(draw);
    }

    function cleanup() {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('resize', resize);
      window.removeEventListener('scroll', onScroll);
    }

    // Initialize
    resize();
    window.addEventListener('resize', resize);
    window.addEventListener('scroll', onScroll, { passive: true });
    draw();

    // Clean up if the section is dynamically removed (Shopify Editor)
    document.addEventListener('shopify:section:unload', (e) => {
      if (e && e.target && e.target.contains(canvas)) {
        cleanup();
      }
    });
  }

  onReady(() => {
    // Only run on homepage
    if (!document.body.className.includes('template-index')) return;
    initConfetti();
  });
})();


